/** @jsx jsx */
import { jsx } from "theme-ui"
import EventForm from "../event-form"

const EventFormPattern = ({ blade, ...restProps }) => {
  return <EventForm sx={{ width: "100%" }} />
}

export default EventFormPattern
